import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import { darken } from 'polished'

const NFTMarketPlaceMenuList = styled.div`
  width: 100%;
  display: flex;
  margin-top: -40px;
  user-select: none;

  ul {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    list-style: none;

    li {
      margin-left: 1rem;
      cursor: pointer;
    }
  }
`

const NFTMarketPlaceMenuLink = styled(NavLink)`
  width: 100%;
  display: flex;
  text-decoration: none;
  color: ${({ theme }) => theme.text1};

  :hover,
  :focus {
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
`

export default function NFTMarketPlaceMenu() {
  return (
    <NFTMarketPlaceMenuList>
      <ul>
        <li>
          <NFTMarketPlaceMenuLink to="/nft-marketplace">Explorer</NFTMarketPlaceMenuLink>
        </li>
        <li>
          <NFTMarketPlaceMenuLink to={`/profile/wallet?tab=on-sale`}>Profile</NFTMarketPlaceMenuLink>
        </li>
        <li>
          <NFTMarketPlaceMenuLink to="/nft-create">Create</NFTMarketPlaceMenuLink>
        </li>
      </ul>
    </NFTMarketPlaceMenuList>
  )
}
